export var KeepaliveSvc = (function () {
    function KeepaliveSvc() {
    }
    return KeepaliveSvc;
}());
//# sourceMappingURL=keepalivesvc.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ng-idle/core/src/keepalivesvc.js
// module id = 751
// module chunks = 3